import { render, staticRenderFns } from "./CustomerFormDeliveryLocations.vue?vue&type=template&id=20bb2ca2&scoped=true&"
import script from "./CustomerFormDeliveryLocations.vue?vue&type=script&lang=ts&"
export * from "./CustomerFormDeliveryLocations.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerFormDeliveryLocations.vue?vue&type=style&index=0&id=20bb2ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb2ca2",
  null
  
)

export default component.exports